import React from "react";
import Cnav from "../Contact-Nav/Cnav";
import Cdetails from "../Contact-details/Cdetails";
import Footer from "../Footer/Footer";

function Fourth() {
  return (
    <div>
      <Cnav galleryColor="black" contactColor="red" />
      <Cdetails />
      <Footer />
    </div>
  );
}

export default Fourth;
